import ApiClient from './ApiClient';

class ContactNotes extends ApiClient {
  constructor() {
    super('notes', { accountScoped: true });
    this.contactId = null;
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/notes`;
  }

  get(contactId) {
    this.contactId = contactId;
    return super.get();
  }

  create(contactId, content, files = []) {
    this.contactId = contactId;
    // Rails so empacota (params.require(:note)) requisicoes JSON - com
    // arquivo precisa ser multipart, entao manda sempre nesse formato,
    // com os colchetes manuais no nome do campo.
    const formData = new FormData();
    formData.append('note[content]', content || '');
    files.forEach(file => formData.append('note[files][]', file));
    return super.create(formData);
  }

  delete(contactId, id) {
    this.contactId = contactId;
    return super.delete(id);
  }
}

export default new ContactNotes();
